import Table from "src/components/Common/UI/DndTable/Table";
import Modal from "src/components/Common/UI/Modal/Modal";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import EditAtm from "../Atms/EditAtm";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useAtmsTable } from "./hooks/useAtmsTable";

const ATMTable = ({unitID}: ATMTableProps) => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    modalEvent
  } = useAtmsTable({unitID: unitID});
  
  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false}  />
);

  return (
    <>   
      <Table
          columns={columns}
          data={data}
          defaultOrderByKeyFilter={"id"}
          showNumberOfRows={false}
          rowSelection={true}
          setRowSelection={setSelectedRowsOfTable}
          multipleRowSelection={false}
          actionRowId={"id"}
          debugMode={false}
          noDataFoundTitle="No Atms yet"
          isChangeOrderOrVisibilityEnable={false}
          ButtonsAreaLeft={ActionButtons}
          hiddenColumnsForUser={["deleted"]}
          textPosition="center"
      />
    

    <Modal
      isOpen={!!modalEvent.action}
      closeFilterModal={closeActionModal}
      title={getModalTitleByAction()}  
      size="xl"
      >
        {modalEvent.action === "edit" && <EditAtm handleCloseModal={closeActionModal} atmId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
    </Modal>

    {!loadingDone && <LoadingSpinner />}
</>
  )
}

export default ATMTable;

interface ATMTableProps {
  unitID: number;
}